import layout from '@/layout/layout.vue';
const plafromRouter = import.meta.glob(['../*iews/**/*.vue', '!../*iews/**/components/*.vue']);
const routes: any = [
    { name: '/', path: '/', component: layout, children: [], redirect: '/home' },
    { path: '/:pathMatch(.*)*', name: 'NotFound', redirect: '/home' },
];

Object.keys(plafromRouter).forEach((item, key) => {
    let realKey = item;
    let name = '';
    realKey = item.replace('../views', '').replace('.vue', '');
    name = realKey.split('/').slice(-1)[0].toLocaleLowerCase();
    if (name === 'login') {
        // 如果是登录模块内就不需要layout组件
        routes.push({ name: name, path: `/${name}`, component: plafromRouter[item] });
    } else {
        routes[0].children.push({ name: name, path: realKey, component: plafromRouter[item] });
    }
});

export const listRouter = routes;
